module.exports = __webpack_public_path__ + "images/c790660a3008194445ce3a80442e7b1b.png";